import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import {
  HomeUpdatedArrowIcon,
  HomeUpdatedNextIcon,
  HomeUpdatedPrevIcon,
  HomeExpertDomainAutomative,
  HomeExpertDomainHealthcare,
  HomeExpertDomainOnDemand,
  HomeExpertDomainEducation,
  HomeExpertDomainMusic,
  HomeExpertDomainFintech,
  HomeExpertDomainLogistics,
  HomeExpertDomainRetail,
  HomeExpertDomainEcommerce,
  HomeExpertDomainRealEstate,
} from "../../../app-constants";
// Import Swiper React components
import "swiper/css";
import { Link } from "gatsby";

import iOne from "../../images/home-update/industries/automotive.webp";
import iTwo from "../../images/home-update/industries/healthcare.webp";
import iThree from "../../images/home-update/industries/ondemand.webp";
import iFour from "../../images/home-update/industries/education.webp";
import iFive from "../../images/home-update/industries/music.webp";
import iSix from "../../images/home-update/industries/fintech.webp";
import iSeven from "../../images/home-update/industries/logistics.webp";
import iTen from "../../images/home-update/industries/retail.webp";
import iEleven from "../../images/home-update/industries/ecommerce.webp";
import iTwelve from "../../images/home-update/industries/realestate.webp";

function Industry(props) {
  const [swiper, setSwiper] = React.useState();
  const prevRef = React.useRef();
  const nextRef = React.useRef();

  React.useEffect(() => {
    if (swiper) {
      console.log("Swiper instance:", swiper);
      swiper.params.navigation.prevEl = prevRef.current;
      swiper.params.navigation.nextEl = nextRef.current;
      swiper.navigation.init();
      swiper.navigation.update();
    }
  }, [swiper]);

  const allCss = `
    .serv-item .serv-inner::before {
      content: '';
    }
    .home-inds-one .serv-inner::before {
      background-image: url(${iOne});
    }
    .home-inds-two .serv-inner::before {
      background-image: url(${iTwo});
    }
    .home-inds-three .serv-inner::before {
      background-image: url(${iThree});
    }
    .home-inds-four .serv-inner::before {
      background-image: url(${iFour});
    }
    .home-inds-five .serv-inner::before {
      background-image: url(${iFive});
    }
    .home-inds-six .serv-inner::before {
      background-image: url(${iSix});
    }
    .home-inds-seven .serv-inner::before {
      background-image: url(${iSeven});
    }

    .home-inds-ten .serv-inner::before {
      background-image: url(${iTen});
    }
    .home-inds-eleven .serv-inner::before {
      background-image: url(${iEleven});
    }
    .home-inds-twelve .serv-inner::before {
      background-image: url(${iTwelve});
    }
      `;

  return (
    <>
      <style>{allCss}</style>
      <section className="tekrevol__industry overflow-x-hidden p-100">
        <Container>
          <Row>
            <Col
              xs={12}
              md={12}
              lg={12}
              xl={6}
              xxl={6}
              className="mt-auto mb-auto"
            >
              <div className="example example-bottom" data-text="Expertise">
                <h2>Expertise Across Domains</h2>
              </div>
            </Col>
            <Col
              xs={12}
              md={12}
              lg={12}
              xl={12}
              xxl={12}
              className="mt-auto mb-auto"
            >
              <div className="industry-wrap">
                <Swiper
                  modules={[Navigation, Pagination]}
                  spaceBetween={25}
                  slidesPerView={3}
                  // onSlideChange={() => console.log('slide change')}
                  // onSwiper={(swiper) => console.log(swiper)}
                  breakpoints={{
                    320: {
                      slidesPerView: 1,
                    },
                    575: {
                      slidesPerView: 1.5,
                    },
                    666: {
                      slidesPerView: 1.8,
                    },
                    768: {
                      slidesPerView: 2,
                    },
                    1199: {
                      slidesPerView: 2,
                    },
                    1200: {
                      slidesPerView: 3,
                    },
                  }}
                  navigation={{
                    prevEl: prevRef?.current,
                    nextEl: nextRef?.current,
                  }}
                  onSwiper={setSwiper}
                  onSlideChange={() => console.log("slide change")}
                  className="industry_serv"
                >
                  <SwiperSlide>
                    <div className="serv-item home-inds-one">
                      <div className="serv-inner">
                        <div className="industry_icon">
                          {HomeExpertDomainAutomative}
                        </div>
                        <Link
                          to="/solution/automotive-app-development"
                          aria-label="Automotive"
                          className="title_wrap"
                        >
                          <h3 className="title">Automotive</h3>
                        </Link>
                        <p>
                          Implement IoT telematics and AI-driven predictive
                          maintenance to optimize fleet management. Gain
                          real-time data for enhanced vehicle performance and
                          reduced downtime. Improve safety and efficiency with
                          advanced analytics.
                        </p>
                        <Link
                          to="/solution/automotive-app-development"
                          aria-label="Automotive"
                        >
                          {HomeUpdatedArrowIcon}
                        </Link>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="serv-item home-inds-two">
                      <div className="serv-inner ">
                        <div className="industry_icon">
                          {HomeExpertDomainHealthcare}
                        </div>
                        <Link
                          to="/healthcare-app-development"
                          aria-label="Healthcare"
                          className="title_wrap"
                        >
                          <h3 className="title">Healthcare</h3>
                        </Link>
                        <p>
                          Utilize HIPAA-compliant telemedicine platforms and
                          integrated EMR/EHR systems for streamlined patient
                          care. Employ AI diagnostics for better outcomes and
                          predictive analytics to enhance operational
                          efficiency.
                        </p>
                        <Link
                          to="/healthcare-app-development"
                          aria-label="Healthcare"
                        >
                          {HomeUpdatedArrowIcon}
                        </Link>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="serv-item home-inds-three">
                      <div className="serv-inner ">
                        <div className="industry_icon">
                          {HomeExpertDomainOnDemand}
                        </div>
                        <Link
                          to="/on-demand-app-development"
                          aria-label="On-Demand"
                          className="title_wrap"
                        >
                          <h3 className="title">On-Demand</h3>
                        </Link>
                        <p>
                          Adopt scalable cloud architectures with real-time GPS
                          tracking and AI-driven demand forecasting. Ensure
                          rapid, reliable service delivery and seamless user
                          experiences. Scale effortlessly with fluctuating
                          demands.
                        </p>
                        <Link
                          to="/on-demand-app-development"
                          aria-label="On-Demand"
                        >
                          {HomeUpdatedArrowIcon}
                        </Link>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="serv-item home-inds-four">
                      <div className="serv-inner ">
                        <div className="industry_icon">
                          {HomeExpertDomainEducation}
                        </div>
                        <Link
                          to="/solution/educational-software-company"
                          aria-label="Education"
                          className="title_wrap"
                        >
                          <h3 className="title">Education</h3>
                        </Link>
                        <p>
                          Leverage VR-enabled learning platforms and AI-driven
                          personalized paths to enhance student engagement.
                          Utilize real-time analytics for adaptive content and
                          improved teaching strategies.
                        </p>
                        <Link
                          to="/solution/educational-software-company"
                          aria-label="Education"
                        >
                          {HomeUpdatedArrowIcon}
                        </Link>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="serv-item home-inds-five">
                      <div className="serv-inner ">
                        <div className="industry_icon">
                          {HomeExpertDomainMusic}
                        </div>
                        <Link
                          to="/solution/music-app-developers"
                          aria-label="Music"
                          className="title_wrap"
                        >
                          <h3 className="title">Music</h3>
                        </Link>
                        <p>
                          Deploy advanced streaming platforms with AI-driven
                          recommendations and blockchain-based royalty
                          management. Maximize revenue, enhance user engagement,
                          and ensure secure transactions.
                        </p>
                        <Link
                          to="/solution/music-app-developers"
                          aria-label="Music"
                        >
                          {HomeUpdatedArrowIcon}
                        </Link>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="serv-item home-inds-six">
                      <div className="serv-inner ">
                        <div className="industry_icon">
                          {HomeExpertDomainFintech}
                        </div>
                        <Link
                          to="/fintech-software-development"
                          aria-label="Fintech"
                          className="title_wrap"
                        >
                          <h3 className="title">Fintech</h3>
                        </Link>
                        <p>
                          Implement blockchain smart contracts, AI-driven fraud
                          detection, and real-time payment processing for secure
                          transactions. Use data analytics for personalized
                          financial solutions and enhanced security.
                        </p>
                        <Link
                          to="/fintech-software-development"
                          aria-label="Fintech"
                        >
                          {HomeUpdatedArrowIcon}
                        </Link>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="serv-item home-inds-seven">
                      <div className="serv-inner ">
                        <div className="industry_icon">
                          {HomeExpertDomainLogistics}
                        </div>
                        <Link
                          to="/solution/logistics-software-development"
                          aria-label="Logistics"
                          className="title_wrap"
                        >
                          <h3 className="title">Logistics</h3>
                        </Link>
                        <p>
                          Optimize operations with AI-driven route planning, IoT
                          tracking, and advanced supply chain analytics. Improve
                          delivery times, reduce costs, and gain real-time
                          visibility and predictive insights.
                        </p>
                        <Link
                          to="/solution/logistics-software-development"
                          aria-label="Logistics"
                        >
                          {HomeUpdatedArrowIcon}
                        </Link>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="serv-item home-inds-ten">
                      <div className="serv-inner ">
                        <div className="industry_icon">
                          {HomeExpertDomainRetail}
                        </div>
                        <Link
                          to="/solution/retail-software-solution"
                          aria-label="Retail"
                          className="title_wrap"
                        >
                          <h3 className="title">Retail</h3>
                        </Link>
                        <p>
                          Integrate AI-powered inventory management and
                          personalized recommendations with omnichannel sales.
                          Drive customer loyalty, optimize stock levels, and
                          increase sales through data-driven insights.
                        </p>
                        <Link
                          to="/solution/retail-software-solution"
                          aria-label="Retail"
                        >
                          {HomeUpdatedArrowIcon}
                        </Link>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="serv-item home-inds-eleven">
                      <div className="serv-inner ">
                        <div className="industry_icon">
                          {HomeExpertDomainEcommerce}
                        </div>
                        <Link
                          to="/solution/ecommerce-app-development"
                          aria-label="E-Commerce"
                          className="title_wrap"
                        >
                          <h3 className="title">E-Commerce</h3>
                        </Link>
                        <p>
                          Enhance platforms with scalable cloud infrastructure,
                          secure payment gateways, and AI-driven customer
                          behavior analytics. Boost conversions, improve user
                          experience, and drive sustained growth.
                        </p>
                        <Link
                          to="/solution/ecommerce-app-development"
                          aria-label="E-Commerce"
                        >
                          {HomeUpdatedArrowIcon}
                        </Link>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="serv-item home-inds-twelve">
                      <div className="serv-inner ">
                        <div className="industry_icon">
                          {HomeExpertDomainRealEstate}
                        </div>
                        <Link
                          to="/solution/real-estate-app-development"
                          aria-label="Real Estate"
                          className="title_wrap"
                        >
                          <h3 className="title">Real Estate</h3>
                        </Link>
                        <p>
                          Modernize with VR property tours, AI-driven
                          valuations, and blockchain smart contracts. Streamline
                          transactions, enhance property visibility, and provide
                          data-driven insights for better decisions.
                        </p>
                        <Link
                          to="/solution/real-estate-app-development"
                          aria-label="Real Estate"
                        >
                          {HomeUpdatedArrowIcon}
                        </Link>
                      </div>
                    </div>
                  </SwiperSlide>
                </Swiper>
                {/* <div ref={prevRef}>Prev</div>
                                      <div ref={nextRef}>Next</div> */}
                <div ref={prevRef} className="custom-button custom-prev-button">
                  {HomeUpdatedPrevIcon}
                </div>
                <div ref={nextRef} className="custom-button custom-next-button">
                  {HomeUpdatedNextIcon}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default Industry;
